import { memo } from 'react';

type LoginButtonProps = {
    text: string;
    icon: string;
    onClick: () => void;
    disabled?: boolean;
    /** Extra classes for the icon, e.g. dark:invert for monochrome logos (Apple). */
    iconClassName?: string;
};

const LoginButton = memo(({ text, icon, onClick, disabled = false, iconClassName = '' }: LoginButtonProps) => {
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={`w-full h-[42px] px-4 border flex items-center justify-center gap-2.5 whitespace-normal text-center relative transition-colors duration-100 ease-in max-[267px]:leading-tight rounded-full bg-white border-grey-70 text-grey-20 dark:bg-primary-10 dark:border-grey-50 dark:text-white ${disabled
                    ? 'opacity-60 cursor-not-allowed'
                    : 'cursor-pointer hover:bg-grey-95 dark:hover:bg-primary-20'
                }`}
        >
            <img
                src={icon}
                className={`w-6 h-6 flex-shrink-0 ${iconClassName}`}
                alt=""
                loading="lazy"
                onError={(e) => {
                    // Hide the image if it fails to load to prevent console errors
                    e.currentTarget.style.display = 'none';
                }}
            />
            <span>{text}</span>
        </button>
    );
});

export default LoginButton;
